module.exports = __webpack_public_path__ + "static/desk-organized-fa84795713535ec7cbdcc08d505bed25.png";